module.exports = __webpack_public_path__ + "static/delivered-59f5819ae3a3417597d86c43d3ddb18c.png";